var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { keyframes } from 'styled-components';
import { css, styled } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
const radius = 7; // in a 24x24 svg viewbox
const circumference = 2 * Math.PI * radius;
const spin = keyframes `0%{transform:rotate(0);}100%{transform:rotate(2turn);}`;
const growth = keyframes `0%{stroke-dashoffset:${circumference};}50%{stroke-dashoffset:${circumference / 4};}100%{stroke-dashoffset:${circumference};}`;
const StyledSpinner = styled.svg.withConfig({ displayName: "StyledSpinner", componentId: "sc-euie9g" }) `${(props) => props.variant === 'default' &&
    css `
			width: ${props.theme.size.static350};
			height: ${props.theme.size.static350};
			stroke-width: ${(100 / parseInt(props.theme.size.static350, 10)) * 2}%;
		`} ${(props) => props.variant === 'large' &&
    css `
			width: ${props.theme.size.static510};
			height: ${props.theme.size.static510};
			stroke-width: ${(100 / parseInt(props.theme.size.static510, 10)) * 2}%;
		`} ${(props) => props.variant === 'x-large' &&
    css `
			width: ${props.theme.size.static625};
			height: ${props.theme.size.static625};
			stroke-width: ${(100 / parseInt(props.theme.size.static625, 10)) * 2}%;
		`}`;
const BackgroundPath = styled.path.withConfig({ displayName: "BackgroundPath", componentId: "sc-5vs9d8" }) `stroke:${(props) => props.theme.colors.signal.info};`;
const ForegroundPath = styled.path.withConfig({ displayName: "ForegroundPath", componentId: "sc-uacxr" }) `stroke:${(props) => props.theme.colors.signal.progress};stroke-dasharray:${circumference} ${circumference};transform-origin:center;animation:2s cubic-bezier(0.41, 0.2, 0.16, 0.59)${spin} infinite,2s cubic-bezier(0.63, 0, 0.58, 1)${growth} infinite;`;
const circlePathData = 'M12,5a7,7 0 1,0 0,14a7,7 0 1,0 0,-14';
export const Spinner = (props) => {
    const { title, variant } = props, rest = __rest(props, ["title", "variant"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(StyledSpinner, Object.assign({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", viewBox: "0 0 24 24", variant: variant || 'default' }, commonProps, rest),
        title && React.createElement("title", null, title),
        React.createElement(BackgroundPath, { d: circlePathData }),
        React.createElement(ForegroundPath, { d: circlePathData })));
};
